export const capitalizeFirstLetter = string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const removeHtmlTags = text =>
  text ? text.replace(/<(.|\n)*?>/g, '') : '';

export default { capitalizeFirstLetter, removeHtmlTags };
